import request from '@/api/request'

/**
 *
 * 获取资讯对应分类列表
 */
export const getInformationList = (params) => {
    return request({
        url: '/radioweb/adm/information/getListPage',
        params,
        method: 'get'
    })
}
/**
 * 添加资讯
 */
export const addInformation = (data) => {
    return request({
        url: '/radioweb/adm/information/addInformation',
        data,
        method: 'post',
        type: 'json'
    })
}
/**
 * 修改资讯
 */
export const updateInformation = (data) => {
    return request({
        url: '/radioweb/adm/information/updateInformation',
        data,
        method: 'post',
        type: 'json'
    })
}
/**
 * 复制资讯
 */
export const copyInformation = (data) => {
    return request({
        url: '/radioweb/adm/information/copyInformation',
        data,
        method: 'post',
        type: 'json'
    })
}
/**
 * 置顶！资讯
 */
export const topInformation = (id) => {
    return request({
        url: `/radioweb/adm/information/updateTopFlag?id=${id}`,
        data: {},
        method: 'post',
    })
}
/**
* 发布！资讯
*/
export const stateformation = (id) => {
    return request({
        url: `/radioweb/adm/information/updateState?id=${id}`,
        data: {},
        method: 'post',
    })
}
/**
 * 删除资讯
 */
export const delInformation = (id) => {
    return request({
        url: `/radioweb/adm/information/delInformation?id=${id}`,
        data: {},
        method: 'post',
    })
}
/**
 * 获取资讯附件
 */
export const getAttachFiles = (id) => {
    return request({
        url: `/radioweb/adm/information/getInformationAttachFileList`,
        method: 'get',
        params: {id}
    })
}
/**
 * 修改资讯类型
 */
export const updateType = (data) => {
    return request({
        url: `/radioweb/adm/information/updateType`,
        method: 'post',
        data
    })
}
